
<div v-if = "incident">
    <v-menu
        nudge-left ="-10"
        nudge-top  ="10"
        v-model    ="changeOpen"
        :close-on-content-click="false"
        close-on-click
        offset-x
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        small
                        fab
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                    >
                        <v-icon color="primary">mdi-swap-horizontal</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t("inc.edit.menu.change") }}</span>
            </v-tooltip>
        </template>

        <c-column-header :label="$t('inc.change.title')" class="primary" title-border>
            <template v-slot:pre>
                <div style="min-width: 18px"></div>
            </template>
        </c-column-header>

        <v-list >
            <template v-for="(item, index) in allowed">
                <v-list-item
                    link
                    :key="index"
                    @click="onChange(item)"
                >
                    <v-list-item-title>
                        {{ item.name }}
                    </v-list-item-title>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</div>
